// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"A0-z","subtitle":"B0-z","wrapper":"C0-z","leftArrow":"D0-z","rightArrow":"E0-z"};